const projects = [
    {
        title: 'Jogo de Trivia',
        description: 'Aplicação de Trivia Game, utilizando React, Redux e estilizado com Tailwind CSS.',
        website: 'https://vsssp.github.io/trivia-react-redux/',
        thumbnail: 'https://github.com/VSSSP/vsssp.github.io/blob/main/src/images/trivia/trivia.png?raw=true',
        buttonText: 'Jogar Trivia',
    },
    {
        title: 'TrybeTunes',
        description: 'Aplicação de stream de músicas utilizando React e estilizado com Bootstrap/CSS.',
        website: 'https://vsssp.github.io/TrybeTunes/',
        thumbnail: 'https://github.com/VSSSP/vsssp.github.io/blob/main/src/images/trybetunes/trybetunes.png?raw=true',
        buttonText: 'Play some music',
    },
    {
        title: 'Star Wars Planets Search',
        description: 'Aplicação de filtros dos planetas do Star Wars utilizando React e estilizado em CSS 3.',
        thumbnail: 'https://github.com/VSSSP/vsssp.github.io/blob/main/src/images/starwars/starwarsplanets.png?raw=true',
        website: 'https://vsssp.github.io/starwars-planets-search/',
        buttonText: 'Filtrar Planetas do Star Wars',
    },
    {
        title: 'Trybewallet',
        description: 'Aplicação de gerenciamento de finanças utilizando React, Redux e estilizado com Bootstrap/CSS.',
        thumbnail: 'https://github.com/VSSSP/vsssp.github.io/blob/main/src/images/trybewallet/wallet.png?raw=true',
        website: 'https://vsssp.github.io/trybewallet/',
        buttonText: 'Gerenciar minha carteira',
    },
    {
        title: 'Recipes-App',
        description: 'Aplicação de receitas de comidas e bebidas utilizando React e estilizado com Bootstrap/CSS.',
        thumbnail: 'https://github.com/VSSSP/vsssp.github.io/blob/main/src/images/recipes-app/foods.png?raw=true',
        website: 'https://vsssp.github.io/recipes-app/',
        buttonText: 'Preparar uma receita',
    },
]

export default projects;